import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { TranslationService } from '../../../core/i18n/translation.service';

@Component({
  selector: 'app-checklist-item-definition-multiscale',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './checklist-item-definition-multiscale.component.html',
  styleUrl: './checklist-item-definition.shared.css',
})
export class ChecklistItemDefinitionMultiscaleComponent {
  readonly options = input.required<FormArray>();
  readonly i18n = input.required<TranslationService>();
  readonly isReadOnly = input(false);
  readonly addOptionRequested = input.required<() => void>();
  readonly removeOptionRequested = input.required<(index: number) => void>();

  protected asFormGroup(control: unknown): FormGroup {
    return control as FormGroup;
  }
}
